import { Box, Button, Divider, Group, Stack } from '@mantine/core';
import { useNavigate, useParams } from 'react-router-dom';
import { IconChevronLeft } from '@tabler/icons-react';
import Swal from 'sweetalert2';

import * as C from '../../../../ui/common/CommonStyles';
import useActivateSlackAlert from './hooks/useActivateSlackAlert';
import useGetModelDetails from './hooks/useGetModelDetails';
import ActivationInfo from './ui/activationInfo';
import ModemBasicInfo from './ui/basicInfo';
import TelecomInfo from './ui/telecomInfo';
import { showSuccessNotification } from '../../../../ui/notification';

export default function ModemDetailsContainer() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { mutate: activateSlackAlert } = useActivateSlackAlert();
  const modemId = Number(id);

  const { data: modemDetails } = useGetModelDetails({ id: modemId });
  const isComplete = modemDetails?.activateStatus === 'COMPLETED';

  const onConfirm = () => {
    Swal.fire({
      title: '개통 요청',
      text: '개통 요청 시 슬랙 채널로 알림이 전송됩니다.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: '확인',
      cancelButtonText: '취소',
    }).then((result) => {
      if (result.isConfirmed) {
        if (!modemDetails) return;
        activateSlackAlert(
          { mac: modemDetails.mac },
          {
            onSuccess: () => {
              showSuccessNotification('개통 요청이 완료되었습니다.', '슬랙 채널로 알림이 전송되었습니다.');
            },
          },
        );
      }
    });
  };

  return (
    <div>
      <C.TitleBox>
        <div className="title">{`모뎀 상세`}</div>
      </C.TitleBox>
      <C.ListBox>
        <Box pos="relative" pt="xs">
          <Stack>
            {modemDetails && (
              <>
                <ModemBasicInfo data={modemDetails} />
                <TelecomInfo data={modemDetails} />
                <ActivationInfo data={modemDetails} />
              </>
            )}
          </Stack>
          <Divider mt="xl" mb="md" />
          <Box pos="absolute" top={0} right={0}>
            <Button color="primary.5" onClick={() => navigate(`/admin/management/modem/register/${modemId}`)} disabled={!id}>
              수정
            </Button>
          </Box>
          <Group justify="center">
            <Button
              variant="default"
              leftSection={<IconChevronLeft size={16} />}
              onClick={() => navigate('/admin/management/modem')}
            >
              목록으로
            </Button>
            <Button color="secondary.5" disabled={!modemDetails?.mac || isComplete} onClick={onConfirm}>
              {isComplete ? '개통 완료' : '개통 요청'}
            </Button>
          </Group>
        </Box>
      </C.ListBox>
    </div>
  );
}
